import { createTokenQueryServiceInstance } from "src/app/core/services/query.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";
import { QueryState } from "src/app/core/models/query.model";
import { IApiKey } from "../core/models/api-key.model";

export const APIKEY_ENDPOINT = 'auth';
export const APIKEY_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(APIKEY_ENDPOINT);


export const apiKeyStateConfig: SignalStoreConfig<QueryState<IApiKey>> = {
    initState: {
      list: [],
      // sort: {
      //   field: 'dataPrelievo',
      //   direction: 'asc'
      // }
    }
  }